import { Apr1Events } from "../../ui/Apr1";

export function apr1(): void {
  Apr1Events.emit();
}
